import React, { useEffect, useRef } from 'react';

export default function AdsenseBanner() {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-1050363489824199"
      data-ad-slot="9636903508"
      data-ad-format="auto"
      data-full-width-responsive="true"
      ref={adRef}
    />
  );
}
